import React from 'react';
import PropTypes from 'prop-types';

import { Pagination } from '@mui/material';
import { makeStyles } from '@mui/styles';

import colorVariables from '../../styles/variables';

/** @type {Object<string, import('@mui/styles').CSSProperties>} */
const styles = {
  paginationRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: '14px',
    color: colorVariables.grey400,
  },
};

const useStyles = makeStyles(styles);

const TlPagination = ({ links, totalDocs, handleChange }) => {
  const classes = useStyles();
  const { totalPages, currentPage } = links;

  return (
    totalPages > 0 && (
      <div className={classes.paginationRow}>
        {totalDocs && (
          <div>
            {totalDocs.toLocaleString()} {totalDocs === 1 ? 'result' : 'results'}
          </div>
        )}
        <div style={{ flex: '1' }} />
        <Pagination count={totalPages} page={currentPage} onChange={handleChange} shape="rounded" />
      </div>
    )
  );
};

TlPagination.defaultProps = {
  totalDocs: null,
};

TlPagination.propTypes = {
  links: PropTypes.shape({
    totalPages: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
  }).isRequired,
  totalDocs: PropTypes.number,
  handleChange: PropTypes.func.isRequired,
};

export default TlPagination;
